import React from "react";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import { oldTimeZoneMapper, handleBlankValue } from "../../../commons/CommonUtils";
import { FormattedMessage } from "react-intl";
import { isINRegion, isNonEmptyList, convertArrayToString } from "../../../util/CommonUtils";

const OrderInfo = (props) => {
    if (!props.data) {
        return null;
    }
    let orderInfo = props.data.orderInfo ? props.data.orderInfo : {};
    let customerInfo = props.data.customerInfo ? props.data.customerInfo : {};
    let shipInfo = props.data.shipInfo ? props.data.shipInfo : {};
    let dateOptions = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: props.data.stationTimeZone? oldTimeZoneMapper(props.data.stationTimeZone): undefined
    };

    let startBusinessHour = customerInfo.businessHours && customerInfo.businessHours.startTime ? new Date(customerInfo.businessHours.startTime)
        .toLocaleString("en-US", dateOptions) : null;
    let endBusinessHour = customerInfo.businessHours && customerInfo.businessHours.endTime ? new Date(customerInfo.businessHours.endTime)
        .toLocaleString("en-US", dateOptions) : null;

    return (
        <Column>
            <Row widths={["grid-3"]} spacingInset="medium large none">
                <Text type="h300"><FormattedMessage id="search.package.orderInfo_customerInfo" defaultMessage="Customer Info"/></Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_name" defaultMessage="Name"/></Text>
                <Text type="b200">{handleBlankValue(customerInfo.customerName)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_address" defaultMessage="Address"/></Text>
                <Text type="b200">{handleBlankValue(customerInfo.customerAddress)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_addressType" defaultMessage="Address type"/></Text>
                <Text type="b200">{handleBlankValue(customerInfo.customerAddressType)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_businessHours" defaultMessage="Business hours"/></Text>
                <Text type="b200">{handleBlankValue(startBusinessHour && endBusinessHour ? startBusinessHour + ' - ' + endBusinessHour : '')}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="medium large none">
                <Text type="h300"><FormattedMessage id="search.package.orderInfo_shipperInfo" defaultMessage="Shipper Info"/></Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_shipperName" defaultMessage="Name"/></Text>
                <Text type="b200">{handleBlankValue(shipInfo.merchantName)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_shipperAddress" defaultMessage="Address"/></Text>
                <Text type="b200">{handleBlankValue(shipInfo.merchantAddress)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="medium large none">
                <Text type="h300"><FormattedMessage id="search.package.orderInfo_orderInfo" defaultMessage="Order Info"/></Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_orderId" defaultMessage="Order Id"/></Text>
                <Text type="b200">{handleBlankValue(orderInfo.orderId)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_orderAmount" defaultMessage="Order amount"/></Text>
                <Text type="b200">{handleBlankValue(orderInfo.orderAmount + ' ' + orderInfo.orderCurrency)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_receivableAmount" defaultMessage="Receivable amount"/></Text>
                <Text type="b200">{handleBlankValue(orderInfo.receivableAmount)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_paymentMethod" defaultMessage="Payment method"/></Text>
                <Text type="b200">{handleBlankValue(orderInfo.paymentMethod)}</Text>
            </Row>
            <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_attendant" defaultMessage="Attendant"/></Text>
                <Text type="b200">{handleBlankValue(orderInfo.attendant)}</Text>
            </Row>
            {isINRegion() ? <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_actualPaymentMethod" defaultMessage="Actual Payment Method"/></Text>
                <Text type="b200">{handleBlankValue(orderInfo.actualPaymentMethod)}</Text>
            </Row> : null}
            {isNonEmptyList(orderInfo.multiBoxTrackingIds) ? <Row widths={["grid-3"]} spacingInset="xsmall large">
                <Text type="h100"><FormattedMessage id="search.package.orderInfo_multiBoxPackages" defaultMessage="Multi-Box Packages"/></Text>
                <Text type="b200">{convertArrayToString(orderInfo.multiBoxTrackingIds)}</Text>
            </Row> : null}
        </Column>
    )
}
 
export default OrderInfo;   



// WEBPACK FOOTER //
// ./src/components/detailPages/packageDetails/OrderInfo.js